import jwt from "jsonwebtoken";
import { getRequest } from "@/views/academy/api/apiRequests";
import { AuthApiEndpoints } from "./AuthApiEndpoints";

const LOGOUT_ROUTE = process.env.VUE_APP_GATEWAY_URL
  ? `${process.env.VUE_APP_GATEWAY_URL}/logout`
  : "http://localhost:8084/rest-api";
// : "https://teambot-test.snlb.pl/rest-api/";

const state = () => ({
  user: null,
  userRoles: null,
  authToken: null,
  isAuthTokenLoaded: false
});

const getters = {
  user: (state: { user: any }) => state.user,
  userRoles: (state: { userRoles: any }) => state.userRoles,
  token: (state: { authToken: any }) => state.authToken,
  isAuthTokenLoaded: (state: { isAuthTokenLoaded: any }) =>
    state.isAuthTokenLoaded
};

const mutations = {
  setUserRoles: (state: { userRoles: any }, payload: { authToken: string }) => {
    const decodedToken: any = jwt.decode(payload.authToken);
    state.userRoles = decodedToken?.roles;
  },

  setToken: (
    state: { authToken: any; isAuthTokenLoaded: any },
    payload: { authToken: any; isAuthTokenLoaded: any }
  ) => {
    state.authToken = payload.authToken;
    state.isAuthTokenLoaded = true;
  },

  clearAuthData: (state: {
    user: null;
    userRoles: null;
    authToken: null;
    isAuthTokenLoaded: boolean;
  }) => {
    state.user = null;
    (state.userRoles = null),
      (state.authToken = null),
      (state.isAuthTokenLoaded = false);
  }
};

const actions = {
  fetchAuthToken: async (context: {
    commit: (arg0: string, arg1: any) => void;
  }) => {
    try {
      const res: any = await getRequest(AuthApiEndpoints.GET_TOKEN);
      context.commit("setToken", { authToken: res?.data });
      context.commit("setUserRoles", { authToken: res?.data });
    } catch (e) {
      console.log(e);
    }
  },

  logout: async (context: { commit: (arg0: string) => void }) => {
    context.commit("clearAuthData");
    window.location.href = LOGOUT_ROUTE;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
